import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

Fancybox.bind('[data-fancybox]', {});

new Swiper('.swiper-testimonial', {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-testimonial-nav .swiper-button-next',
    prevEl: '.swiper-testimonial-nav .swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-testimonial-controls .swiper-scrollbar',
  },
  breakpoints: {
    450: { slidesPerView: 1.15 },
    570: { slidesPerView: 1.5 },
    830: { slidesPerView: 2.15 },
    1060: { slidesPerView: 2.5 },
    1390: { slidesPerView: 3.25 },
  },
});
